import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { BLACK_300, checkIsPlatform, getTestId, SkeletonLoader } from '@airtel/air-design-system';
import { useEffect, useRef, useState } from 'react';
import { View } from 'react-native';
import { TitleAndBanner } from '../title-and-banner/TitleAndBanner';
import { getGridScrollListStyles } from './GridScrollListStyles';
export var GridScrollList = props => {
  var title = props.title,
    infoTagProps = props.infoTagProps,
    showCallout = props.showCallout,
    calloutWidgetProps = props.calloutWidgetProps,
    onUserAction = props.onUserAction,
    pageSize = props.pageSize,
    data = props.data,
    id = props.id,
    renderDynamicListItem = props.renderDynamicListItem,
    testID = props.testID,
    _props$enableLazyLoad = props.enableLazyLoading,
    enableLazyLoading = _props$enableLazyLoad === void 0 ? true : _props$enableLazyLoad,
    numberOfColumn = props.numberOfColumn;
  var gridScrollListStyles = getGridScrollListStyles(props);
  var ref = useRef(null);
  var _useState = useState(0),
    page = _useState[0],
    setPage = _useState[1];
  var _useState2 = useState([]),
    loadedData = _useState2[0],
    setLoadedData = _useState2[1];
  useEffect(() => {
    if (checkIsPlatform('web') && enableLazyLoading) {
      var observer = new IntersectionObserver(entries => {
        var _a;
        if ((_a = entries[0]) === null || _a === void 0 ? void 0 : _a.isIntersecting) {
          if ((loadedData === null || loadedData === void 0 ? void 0 : loadedData.length) < (data === null || data === void 0 ? void 0 : data.length)) {
            setTimeout(() => {
              loadData();
            }, 1000);
          }
        }
      }, {
        threshold: 1
      });
      if (ref.current) {
        observer.observe(ref.current);
      }
      return () => {
        if (ref.current) {
          observer.unobserve(ref.current);
        }
      };
    } else {
      sendImpression();
    }
  }, [ref, loadedData]);
  useEffect(() => {
    if (!checkIsPlatform('web') || !enableLazyLoading) {
      setLoadedData(data);
      setPage(0);
    }
  }, [data]);
  var sendImpression = () => {
    data === null || data === void 0 ? void 0 : data.forEach((item, index) => {
      (item === null || item === void 0 ? void 0 : item.onItemImpression) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id
      }, item.onItemImpression), {
        index,
        item
      }));
    });
  };
  var loadData = () => {
    setLoadedData(prev => {
      var list = [...data.slice(page * pageSize, Math.min(data === null || data === void 0 ? void 0 : data.length, (page + 1) * pageSize))];
      if (page === 0) {
        return list;
      }
      list.map(item => {
        (item === null || item === void 0 ? void 0 : item.onItemImpression) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({}, item.onItemImpression), {
          item
        }));
      });
      return [...prev, ...list];
    });
    setPage(page + 1);
  };
  return _jsxs(_Fragment, {
    children: [_jsx(TitleAndBanner, Object.assign({
      title: title,
      infoTagProps: infoTagProps,
      showCallout: showCallout,
      calloutWidgetProps: calloutWidgetProps,
      onUserAction: onUserAction
    }, getTestId(testID, 'TitleAndBanner'))), _jsxs(View, Object.assign({
      style: gridScrollListStyles.gridContainer
    }, {
      children: [(loadedData === null || loadedData === void 0 ? void 0 : loadedData.length) > 0 && (loadedData === null || loadedData === void 0 ? void 0 : loadedData.map((dataElm, index) => {
        var totalRows = Math.ceil(loadedData.length / numberOfColumn);
        var isLastRow = Math.floor(index / numberOfColumn) === totalRows - 1;
        return _jsx(View, Object.assign({
          style: [gridScrollListStyles.gridItem, isLastRow && {
            paddingBottom: 0
          }]
        }, {
          children: renderDynamicListItem({
            item: Object.assign({}, dataElm),
            index
          })
        }), "loadedData_" + index);
      })), (loadedData === null || loadedData === void 0 ? void 0 : loadedData.length) < (data === null || data === void 0 ? void 0 : data.length) && _jsx(View, Object.assign({
        style: [gridScrollListStyles.gridItem, {
          paddingBottom: 0
        }]
      }, {
        children: _jsx(SkeletonLoader, {
          ref: ref,
          animationDuration: 1500,
          color: BLACK_300,
          type: "card-medium",
          fullWidth: true
        })
      }))]
    }))]
  });
};